import React from 'react'
import styled, { css } from 'styled-components/macro';
import PropTypes from 'prop-types';

const CheckboxLine = ({ amount, label, checked, styleName = 'default', ...props }) => {
  const getPrice = (price) => {
    if(price==null) return '';

    return isNaN(amount) ? 'N/A' : `$${amount}`
  }

  return (
    <Box checked={checked} intent={styleName}>
      <Label>
        <InputWrap>
          <input type="checkbox" {...props} checked={checked} />
          <CheckMark className={`cbl-checkmark ${styleName}`} />
        </InputWrap>
        <Span>{label}</Span>
        <PriceSpan>{getPrice(amount)}</PriceSpan>
      </Label>
    </Box>
  )
}

export default CheckboxLine;

CheckboxLine.propTypes = {
  checked: PropTypes.bool.isRequired,
};

CheckboxLine.defaultProps = {
  checked: false,
};

// styles
const Box = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  background: #0f172a;
  border: 1px solid rgba(255, 255, 255, 0.06);
  ${({ checked, intent }) => checked && intent === 'success' && css`
    background: rgba(34, 197, 94, 0.12);
    border-color: rgba(34, 197, 94, 0.4);
  `}
  ${({ checked, intent }) => checked && intent === 'danger' && css`
    background: rgba(239, 68, 68, 0.12);
    border-color: rgba(239, 68, 68, 0.4);
  `}
`

const Label = styled.label`
  margin: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: #e5e7eb;
  line-height: 1;
`;

const CheckMark = styled.span`
  position: relative;
  display: block;
  height: 22px;
  width: 22px;
  border: 1px solid #475569;
  background-color: #0b1220;
  border-radius: 6px;
  transition: all 150ms;

  &.success {
    border: 1px solid #22c55e;
  }

  &.danger {
    border: 1px solid #ef4444;
  }
 
  &:after {
    display: none;
    content: "";
    position: absolute;
    left: 6px;
    top: 3px;
    width: 7px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  } 
`;

const InputWrap = styled.div`
  height: 22px;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;

    &:checked + .cbl-checkmark {
      background-color: #22c55e;
      border-color: #22c55e;

      &.success {
        border: 1px solid #22c55e;
        background-color: #22c55e;
      }

      &.danger {
        border: 1px solid #ef4444;
        background-color: #ef4444;
      }
    }

    &:checked ~ ${CheckMark}:after {
      display: block;
    }
  }
`

const Span = styled.span`
  color: inherit;
  font-weight: 700;
  font-size: 14px;
  color: #e5e7eb;
  margin-left: 10px;
  flex: 1;
`;

const PriceSpan = styled.span`
  color: inherit;
  font-weight: 700;
  font-size: 14px;
  color: #e5e7eb;
  margin-left: 12px;
`;
